import {
	AlertDialog,
	AlertDialogCancel,
	AlertDialogContent,
	AlertDialogDescription,
	AlertDialogFooter,
	AlertDialogHeader,
	AlertDialogTitle,
	AlertDialogTrigger,
} from '@/components/ui/alert-dialog';
import { Button } from '@/components/ui/button';
import { trpc } from '@/lib/trpc';
import { Trash } from 'lucide-react';
import { useTranslation } from 'react-i18next';
// import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';

const UserDeleteButton = () => {
	const { t } = useTranslation();
	// const navigate = useNavigate();
	const { mutate, isPending } = trpc.user.delete.useMutation();
	const utils = trpc.useUtils();

	return (
		<AlertDialog>
			<AlertDialogTrigger asChild>
				<Button variant="destructive" className="w-full">
					<Trash className="mr-2 h-4 w-4" />
					{t('common.delete')}
				</Button>
			</AlertDialogTrigger>
			<AlertDialogContent>
				<AlertDialogHeader>
					<AlertDialogTitle className="text-left">
						{t('user.delete.confirm.title')}
					</AlertDialogTitle>
					<AlertDialogDescription className="text-left">
						{t('profile.delete.description')}
					</AlertDialogDescription>
				</AlertDialogHeader>
				<AlertDialogFooter>
					<AlertDialogCancel>{t('common.cancel')}</AlertDialogCancel>
					<Button
						className="w-full"
						variant="destructive"
						onClick={() => {
							mutate(undefined, {
								onSuccess: () => {
									toast.success(t('user.delete.success'));
									utils.invalidate();
									// setTimeout(() => {
									// 	navigate('/');
									// }, 1000);
								},
							});
						}}
						disabled={isPending}
					>
						<Trash className="mr-2 h-4 w-4" />
						{t('common.delete')}
					</Button>
				</AlertDialogFooter>
			</AlertDialogContent>
		</AlertDialog>
	);
};

export default UserDeleteButton;
